import GatsbyImageWrapper from '../../GatsbyImageWrapper';
import LocalePrice from '@progymedia/gatsby-theme-boutik-ecommerce/src/utils/LocalePrice';
import React from 'react';
import popFrontURL from '../../../utils/popFrontURL';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useProductPrice } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/store';

export function AccessorySingle(props: {
    product: any;
    isPerfectMatch: boolean;
}) {
    const { product, isPerfectMatch } = props;
    const { navigateTranslated, currentLocale } = usePageLocalization();

    const [price] = useProductPrice(product?.code);

    const navigateToAccessory = (product: any) => {
        if (product) {
            const link = popFrontURL(product?.slug?.[currentLocale], 2);

            if (link) {
                navigateTranslated(link);
            }
        }
    };

    return (
        <>
            <div
                className={`product ${
                    isPerfectMatch ? 'perfect-match' : 'search-accessories'
                }`}
                onClick={() => {
                    navigateToAccessory(product);
                }}
            >
                <div className='product-image'>
                    <GatsbyImageWrapper fields={product.fields} />
                </div>
                <div className='product-info'>
                    <span className='code'>{product.code}</span>
                    <span className='title'>
                        {product?.title?.[currentLocale]}
                    </span>{' '}
                    {price?.discount ? (
                        <div>
                            <span
                                className='price'
                                style={{
                                    textDecoration: 'line-through',
                                    marginRight: '10px',
                                    color: '#b2aca2',
                                }}
                            >
                                {LocalePrice(
                                    currentLocale,
                                    price?.regularPrice.value
                                )}
                            </span>
                            <span
                                className='price'
                                style={{ color: '#d65e2a' }}
                            >
                                {LocalePrice(
                                    currentLocale,
                                    price?.finalPrice.value
                                )}
                            </span>
                        </div>
                    ) : (
                        <span className='price'>
                            {LocalePrice(
                                currentLocale,
                                price?.regularPrice.value
                            )}
                        </span>
                    )}
                </div>
            </div>
        </>
    );
}
